export const roleTypeOperator = ["OperatorAdmin", "OperatorUser"];

export const roleTypeSap = ["SAPAdmin", "SAPUser","RiskAdmin"];

export const roleTypeGroup = ["GroupAdmin", "GroupUser"];

export const disableConfigData = ["OperatorUser", "SAPUser"];

export const SapRoles = {
  SAPAdmin: "SAPAdmin",
  SAPUser: "SAPUser",
  OperatorAdmin: "OperatorAdmin",
  OperatorUser: "OperatorUser",
  GroupAdmin: "GroupAdmin",
  GroupUser: "GroupUser",
  RiskAdmin: "RiskAdmin",
  RolexAdmin: "RolexAdmin",
};

export const SettlementUsers = ["runmatrix","adambo1","yogithbo1","harrybo1","freakbo1","tonybo1","roybo1","sonubo1"];
export const B2BUserMangUsers = ["vivekops"];
